/**
 * @class
 * @extends Error
 */
export class SDKError extends Error {
    constructor(message, { code, data, reason } = {}) {
        super();
        this.name = 'SDKError';
        this.message = message;

        this.code = code;
        this.data = data;
        this.reason = reason;
    }
}

export class SDKCancelRequestError extends Error {
    constructor() {
        super();
        this.name = 'SDKCancelRequestError';
        this.isCancel = true;
    }
}

/**
 * @class
 * @extends Error
 */
export class SDKValidationError extends SDKError {
    constructor(message, { reason } = {}) {
        super(message, { reason });
        this.name = 'SDKValidationError';
    }
}
